import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import PlayCircleFilled from "@mui/icons-material/PlayCircleFilled";
import { IconButton, Tooltip } from "@mui/material";
import { $getSelection, $isNodeSelection } from "lexical";
import type { FC } from "react";
import { useCallback } from "react";
import { $isDesignHuddleNode } from "../../nodes/design-huddle-node";
import { $isVideoNode } from "../../nodes/video-node";
import { floatingToolbarStyles } from "./floating-toolbar-styles";
import type { ToolbarProps } from "./props";

export const VideoLinkButton: FC<ToolbarProps> = ({ disabled, mode }) => {
  const [editor] = useLexicalComposerContext();

  const getVideoLink = useCallback((): string | undefined => {
    return editor.getEditorState().read(() => {
      const selection = $getSelection();
      if (!selection) return undefined;

      if ($isNodeSelection(selection)) {
        const nodes = selection.getNodes();
        return nodes.length === 1 &&
          ($isVideoNode(nodes[0]) ||
            ($isDesignHuddleNode(nodes[0]) && nodes[0].__contentType === "video"))
          ? nodes[0].getHref()
          : undefined;
      }

      return undefined;
    });
  }, [editor]);

  return (
    <>
      <Tooltip title="Preview video in new tab">
        <IconButton
          data-analytics-id={`lexical-${mode}-video-link`}
          disabled={disabled}
          data-testid={`${mode}-button-video-link`}
          aria-label="Video Link"
          tabIndex={-1}
          onClick={() => {
            window.open(getVideoLink(), "_blank");
          }}
          sx={{
            ...floatingToolbarStyles[mode].button,
          }}
        >
          <PlayCircleFilled sx={floatingToolbarStyles[mode].formatIcon} />
        </IconButton>
      </Tooltip>
    </>
  );
};
